"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var houston_tokens_1 = tslib_1.__importDefault(require("@eduzz/houston-tokens"));
/**
 * @deprecated
 */
function createTheme(brand, variables) {
    return tslib_1.__assign(tslib_1.__assign({}, (0, houston_tokens_1.default)(brand)), { variables: variables });
}
exports.default = createTheme;
